<div fxFill>

  <router-outlet></router-outlet>

</div>